<template>
  <div class="main-container" :style="'background-image: url('+profileUser.backgroundImage+')'">
      <div class="overlay middle">
          <div class="profile flex dir-column ai-center">
              <div class="edit-profile" v-if="isOwner" @click="editProfilePage">
                  <h1>Edit Profile <i class="fas fa-external-link-alt"></i></h1>
              </div>
              <img :src="profileUser.profileImage" :alt="profileUser.username" class="profile-image" />
              <div class="row">
                  <h1 class="profile-title">{{ profileUser.username }}</h1>
              </div>
              <div class="row" v-for="(item, index) in links" :key="index">
                  <LinkButton :link="item.link" :name="item.name" />
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import UserService from './../services/userService'
import LinkButton from './../components/LinkButton.vue'
import Cookies from 'js-cookie';

export default {
    name: 'Profile',
    data() {
        return {
            currentUsername: '',
            profileUser:{},
            links:[],
            isOwner: false,
            sessionUsername:''
        }
    },
    components: {
        LinkButton
    },
    async created() {
        await this.getProfile();
        this.setLinks();
        await this.findOwner();
    },
    methods: {
        async getProfile() {
            this.currentUsername = this.$route.params.id;

            const result = await UserService.getProfile(this.currentUsername);
            
            if (result.status == 400) {
                this.$router.push('/');
            }
            
            this.profileUser = result.data.Profile;
        },
        setLinks() {
            let accounts = this.profileUser.accounts;
            if (accounts.instagram) {
                this.links.push({
                    name: 'instagram',
                    link: accounts.instagram
                });
            }
            if(accounts.twitch) {
                this.links.push({
                    name: 'twitch',
                    link: accounts.twitch
                });
            }
            if(accounts.youtube) {
                this.links.push({
                    name: 'youtube',
                    link: accounts.youtube
                });
            }
            if(accounts.twitter) {
                this.links.push({
                    name: 'twitter',
                    link: accounts.twitter
                });
            }
            if(accounts.website) {
                this.links.push({
                    name: 'website',
                    link: accounts.website
                });
            }
        },
        async findOwner() {
            const userId = Cookies.get('user-id');

            const user = await UserService.getUser({ userId });

            this.sessionUsername = user.data.username;

            if (this.sessionUsername == this.profileUser.username) {
                this.isOwner = true;
            }
        },
        editProfilePage() {
            this.$router.push('/editProfile');
        }
    }
}
</script>

<style scoped>

.main-container {
    width: 100%;
    height: 100vh;
    background-color: rgb(0, 89, 255);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.6);
}

.profile {
    width: 450px;
    border: 3px solid black;
    border-radius: 5px;
    background-color: rgba(0,0,0,.4);
    padding: 10px;
    position: relative;
    padding-top: 40px;
}

.profile-image {
    width: 110px;
    height: 110px;
    margin-block: 20px;
    border-radius: 50%;
}

.profile-title {
    text-align: center;
    color: white;
    font-family: 'Mulish' , sans-serif;
    letter-spacing: 2px;
    text-transform: uppercase;
}

.row {
    margin-block: 20px;
    width: 100%;
    height: 40px;
}

.edit-profile {
    font-family: 'Mulish', sans-serif;
    font-size: 10px;
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    letter-spacing: 1px;
    cursor: pointer;
    font-weight: 500;
}

</style>